import type { FunnelStageCount } from '@/features/negociacoes/types';
import type { FunnelStagePercentages } from '../types/analytics.types';

/**
 * Percentuais do funil com clamp em 100: as etapas não são monotônicas (ACORDO_FECHADO vem de
 * status e inclui acordos manuais sem mensagem, então uma etapa posterior pode superar a
 * anterior). `pctPrev` é `null` na 1ª etapa e quando a etapa anterior tem 0 casos, evitando
 * exibir queda de -100% sobre um funil zerado. Fonte única para o card e o export não divergirem.
 */
export const computeFunnelPercentages = (funnel: FunnelStageCount[]): FunnelStagePercentages[] => {
  const firstTotal = funnel[0]?.total ?? 0;

  return funnel.map((stage, index) => {
    const prevTotal = index > 0 ? funnel[index - 1].total : null;
    return {
      pctFirst: firstTotal > 0 ? Math.min(100, (stage.total / firstTotal) * 100) : 0,
      pctPrev:
        prevTotal !== null && prevTotal > 0 ? Math.min(100, (stage.total / prevTotal) * 100) : null,
    };
  });
};
